'use client';

import { usePrefersReducedMotion } from '@/hooks';
import Image from 'next/image';
import { useCallback, useState } from 'react';

interface AvatarAmbientGlowProps {
  src: string;
}

export function AvatarAmbientGlow({ src }: AvatarAmbientGlowProps) {
  const prefersReducedMotion = usePrefersReducedMotion();
  const [loaded, setLoaded] = useState(false);

  const handleLoad = useCallback(() => setLoaded(true), []);

  if (prefersReducedMotion) return null;

  return (
    <div aria-hidden="true" className="pointer-events-none absolute -inset-8 z-0">
      <Image
        src={src}
        alt=""
        fill
        unoptimized
        className={`scale-100 rounded-full object-cover transition-opacity duration-700 ${loaded ? 'opacity-15' : 'opacity-0'}`}
        style={{
          filter: 'blur(40px) saturate(1.6) brightness(0.6)',
        }}
        onLoad={handleLoad}
      />
    </div>
  );
}
